module.exports = __webpack_public_path__ + "static/media/coldstorage4.6f71a1ea.jpg";